import {Plugin, type Transaction} from 'prosemirror-state';
import Table from '@tiptap/extension-table';

export const TimeWebkitTableExtension = Table.extend({
    addProseMirrorPlugins() {
        return [
            new Plugin(
                {
                    appendTransaction: (transactions, oldState, state) => {
                        let tr: Transaction | null = null;

                        const transaction = transactions[0];
                        if (!transaction) {
                            return null;
                        }

                        const isPaste = transaction.getMeta('uiEvent') === 'paste';
                        const isDrop = transaction.getMeta('uiEvent') === 'drop';

                        if (!isPaste && !isDrop) {
                            return null;
                        }

                        const from = oldState.doc.content.findDiffStart(state.doc.content);
                        const to = oldState.doc.content.findDiffEnd(state.doc.content);

                        if (!from || !to) {
                            return null;
                        }

                        let previousTableInterval: [number, number];
                        state.doc.nodesBetween(from, to.b, (node, pos) => {
                            if (node.type.name === 'table') {
                                if (previousTableInterval) {
                                    const [prevTableStart, prevTableEnd] = previousTableInterval;
                                    if (prevTableStart < pos && pos < prevTableEnd) {
                                        tr = state.tr.delete(pos, pos + node.nodeSize);
                                    }
                                }

                                previousTableInterval = [pos, node.nodeSize];
                            }
                        });

                        return tr;
                    },
                },
            ),
        ];
    },
});
